import styled from 'styled-components';
import {regularColor, hiddenColor} from '../config';

export const StyledTag = styled.div`
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
    padding: 7px;
    border: solid 1px var(--color-gray-light);
    width: fit-content;

    &.regular {
        background-color: ${regularColor};
        color: var(--color-white);
    }

    &.hidden {
        background-color: ${hiddenColor};
        color: var(--color-white);
    }
`;
